import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 24px;
  background: ${({ theme }) => theme.customTheme.palette.footer.bgColor};
  display: flex;
  flex-direction: column;
  min-height: 276px;
`;

export const FooterItem = styled.li`
  font-family: ThemeFontBold;
  padding: 12px 0;
  border-bottom: 1px solid ${({ theme }) => theme.customTheme.palette.footerItem.bottomBorder};
  list-style: none;

  a {
    font-weight: 700;
    font-size: ${({ theme }) => theme.customTheme.pxToRem(16)};
    line-height: ${({ theme }) => theme.customTheme.pxToRem(20)};
    color: ${({ theme }) => theme.customTheme.palette.footerItem.textColor};
    text-decoration: none;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    border-bottom: none;
    border-right: 1px solid ${({ theme }) => theme.customTheme.palette.white.standard};
    padding: 6px 16px;

    &:last-child {
      border-right: none;
    }
  }
`;

export const CopyRightItem = styled.p`
  font-weight: 400;
  font-family: ThemeFontRegular;
  font-size: ${({ theme }) => theme.customTheme.pxToRem(14)};
  color: ${({ theme }) => theme.customTheme.palette.copyRight.textColor};
  border-bottom: none;
  text-align: center;
  padding-top: 12px;
  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    padding-top: 24px;
  }
`;

export const FooterContent = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    flex-direction: row;
    justify-content: center;
    padding: 16px 0;
    border-bottom: 1px solid ${({ theme }) => theme.customTheme.palette.FooterContent.bottomBorder};
  }
`;
